export default __webpack_public_path__ + "static/media/offices-popup.705dea41.png";